<div class="ui-wrapper">
  <app-ui-infobar-top></app-ui-infobar-top>
  <app-ui-sidebar-left></app-ui-sidebar-left>
  <app-ui-sidebar-right></app-ui-sidebar-right>
  <!-- <app-ui-infobar-bottom></app-ui-infobar-bottom> -->
  <app-ui-infobar-bottom></app-ui-infobar-bottom>
</div>
